export class Search {
  page: number;
  pageSize: number;
  minimumEtag: Date;
  filters: SearchFilter[];
}

export class SearchFilter {
  value: string;
  type: any;
}
